import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";

const LoginRedirectPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      await fetchAuthSession();
      try {
        await getCurrentUser();
      } catch {}
      navigate("/", { replace: true });
    })();
  }, [navigate]);

  return (
    <Box display="flex" flexDirection={"row"} justifyContent={"center"}>
      <Typography>Logging In...</Typography>
    </Box>
  );
};

export default LoginRedirectPage;
